import { createFileRoute } from "@tanstack/react-router";
import { MailgunLogs } from "@/components/Notifications/MailgunLogs";
import { PageHeader } from "@/components/PageHeader";

function RouteComponent() {
  return (
    <>
      <PageHeader title="Notifications" subtitle="SMTP email delivery logs via Mailgun." />
      <MailgunLogs />
    </>
  );
}

export const Route = createFileRoute("/_authenticated/notifications/")({
  component: RouteComponent,
  staticData: { page: "analytics" },
});
